export default [
  {
    type: 'ColumnSet',
    columns: [
      {
        type: 'Column',
        items: [
          {
            type: 'Image',
            style: 'person',
            url: '{{personImageUrl}}',
            size: 'small',
          },
        ],
        width: 'auto',
      },
      {
        type: 'Column',
        items: [
          {
            type: 'TextBlock',
            weight: 'bolder',
            text: '{{personFullName}} @ {{personOrgName}}',
            wrap: true,
          },
          {
            type: 'TextBlock',
            spacing: 'None',
            text: 'Created July 28th',
            isSubtle: true,
            wrap: true,
          },
        ],
        width: 'stretch',
      },
    ],
  },
];
